'use client'

import { useEffect, useRef } from 'react'

const msgs = [
  {t:'sent', m:'Good morning! Check my emails and calendar for today'},
  {t:'recv', m:'Good morning! ☀️\n\n*12 new emails* — 3 important:\n\n📧 *AWS Billing* — $847 due Friday\n📧 *Ahmed (TechCorp)* — Partnership proposal\n📧 *Sarah HR* — Team offsite March 15, needs RSVP'},
  {t:'recv', m:'📅 Today\'s schedule:\n\n09:00 — Team standup\n11:00 — Q1 Review\n14:00 — Client call (Omar)\n16:30 — 1:1 with Sarah\n\n⚠️ Q1 Review conflicts with dentist at 11:30'},
  {t:'sent', m:'Move dentist to Thursday. Reply to Ahmed — interested, ask for pricing. RSVP yes to offsite'},
  {t:'recv', m:'All done! ✅\n\n🔄 Dentist → Thursday 11:30\n✉️ Reply sent to Ahmed\n✅ RSVP\'d YES to offsite\n📌 Reminder set: follow up Friday'},
  {t:'sent', m:'Design a banner for our product launch — modern, dark theme with our brand colors'},
  {t:'recv', m:'image', rich:true},
  {t:'recv', m:'Here\'s your launch banner! 🎨\n\n3 sizes ready:\n📐 1200×628 — Facebook/LinkedIn\n📐 1080×1080 — Instagram\n📐 1500×500 — Twitter header\n\nWant any changes?'},
  {t:'sent', m:'I need February\'s expense report'},
  {t:'recv', m:'file', rich:true, data:{name:'Feb_2026_Expenses.xlsx', size:'124 KB', rows:47}},
  {t:'recv', m:'*Summary:*\n💰 Total: $12,847\n📈 vs Jan: +8.3%\n🏷️ Top: Software ($4,200)\n\n*47 transactions* auto-categorized'},
  {t:'sent', m:'Heading to bed. Night mode please'},
  {t:'recv', m:'Night mode activated! 🌙\n\n💡 Lights — OFF\n❄️ AC → 23°C\n🔒 Door locked\n⏰ Alarm → 7:00 AM\n\nGoodnight! 😴'},
]

export default function PhoneWidget() {
  const chatRef = useRef<HTMLDivElement>(null)
  const typingRef = useRef<HTMLDivElement>(null)
  const idxRef = useRef(0)
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    const chat = chatRef.current
    const typing = typingRef.current
    if (!chat || !typing) return

    function addMsg(m: any) {
      const d = document.createElement('div')
      d.className = 'oh-wa-msg ' + m.t
      const now = new Date()
      const ts = now.getHours() + ':' + (now.getMinutes() < 10 ? '0' : '') + now.getMinutes()
      let html = ''

      if (m.rich && m.m === 'image') {
        html += '<div class="oh-wa-img"><div class="oh-wa-img-inner" style="min-height:120px">'
        html += '<div style="font-size:32px;margin-bottom:6px">🎨</div>'
        html += '<div style="color:#fff;font-size:12px;font-weight:700">Product Launch Banner</div>'
        html += '<div style="color:rgba(255,255,255,.5);font-size:9px;margin-top:4px">1200 × 628 px</div>'
        html += '</div></div>'
      } else if (m.rich && m.m === 'file' && m.data) {
        html += '<div style="background:rgba(0,168,132,.08);border:1px solid rgba(0,168,132,.2);border-radius:6px;padding:8px;margin-bottom:4px;display:flex;align-items:center;gap:8px">'
        html += '<div style="width:36px;height:42px;background:#1e7145;border-radius:4px;display:flex;align-items:center;justify-content:center;flex-shrink:0"><span style="color:#fff;font-size:9px;font-weight:700">XLS</span></div>'
        html += '<div><div style="color:#e9edef;font-size:11px;font-weight:500">' + m.data.name + '</div>'
        html += '<div style="color:#8696a0;font-size:9px">' + m.data.rows + ' rows · ' + m.data.size + '</div></div></div>'
      } else {
        html = m.m.replace(/\n/g, '<br>').replace(/\*([^*]+)\*/g, '<b>$1</b>')
      }

      html += '<span class="oh-time">' + ts + '</span>'
      d.innerHTML = html
      chat!.insertBefore(d, typing)
      chat!.scrollTop = chat!.scrollHeight
      setTimeout(() => { chat!.scrollTop = chat!.scrollHeight }, 100)
    }

    function showMsg() {
      if (idxRef.current >= msgs.length) {
        idxRef.current = 0
        while (chat!.firstChild) chat!.removeChild(chat!.firstChild)
        chat!.appendChild(typing!)
        typing!.style.display = 'none'
        timerRef.current = setTimeout(showMsg, 5000)
        return
      }
      const m = msgs[idxRef.current] as any
      const isRich = m.rich ? true : false
      if (m.t === 'recv') {
        typing!.style.display = 'flex'
        chat!.scrollTop = chat!.scrollHeight
        timerRef.current = setTimeout(() => {
          typing!.style.display = 'none'
          addMsg(m)
          idxRef.current++
          timerRef.current = setTimeout(showMsg, isRich ? 4000 : 3000)
        }, isRich ? 2500 : 1800)
      } else {
        addMsg(m)
        idxRef.current++
        timerRef.current = setTimeout(showMsg, 3500)
      }
    }

    showMsg()
    return () => { if (timerRef.current) clearTimeout(timerRef.current) }
  }, [])

  return (
    <>
      <style dangerouslySetInnerHTML={{__html: `
.oh-phone{position:relative;width:320px;margin:0 auto}
.oh-phone-outer{position:relative;aspect-ratio:393/852;border-radius:46px;padding:2px;background:linear-gradient(160deg,#e8c8a0,#d4a06c 25%,#c08848 50%,#d4a06c 75%,#e8c8a0);box-shadow:0 30px 60px rgba(0,0,0,.5),0 0 0 .5px rgba(0,0,0,.3),inset 0 .5px 0 rgba(255,255,255,.5)}
.oh-phone-frame{background:#0a0a0a;border-radius:44px;height:100%;padding:3px;position:relative}
.oh-phone-inner{background:#000;border-radius:42px;overflow:hidden;height:100%;position:relative;display:flex;flex-direction:column;min-height:0}
.oh-phone-outer::before{content:'';position:absolute;right:-3px;top:23%;width:3px;height:8%;background:linear-gradient(180deg,#e8c8a0,#c08848,#e8c8a0);border-radius:0 2px 2px 0}
.oh-phone-vol{position:absolute;left:-3px;width:3px;background:linear-gradient(180deg,#e8c8a0,#c08848,#e8c8a0);border-radius:2px 0 0 2px}
.oh-phone-vol1{top:14%;height:2%}
.oh-phone-vol2{top:20%;height:6%}
.oh-phone-vol3{top:28%;height:6%}
.oh-phone-notch{position:absolute;top:8px;left:50%;transform:translateX(-50%);z-index:5;width:110px;height:30px;background:#000;border-radius:18px}
.oh-phone-notch::before{content:'';position:absolute;right:24px;top:50%;transform:translateY(-50%);width:10px;height:10px;border-radius:50%;background:radial-gradient(circle at 35% 35%,#182830,#0a1218);box-shadow:0 0 0 1px #111}
.oh-phone-screen{flex:1;background:#0b141a;display:flex;flex-direction:column;min-height:0;overflow:hidden}
.oh-phone-statusbar{height:44px;flex-shrink:0;background:#0b141a;display:flex;align-items:center;padding:12px 20px 0;justify-content:space-between;position:relative;z-index:4}
.oh-sb-time{color:#fff;font-size:15px;font-weight:600;font-family:-apple-system,sans-serif;letter-spacing:-.2px}
.oh-sb-right{display:flex;align-items:center;gap:5px}
.oh-sb-signal{display:flex;gap:1.5px;align-items:flex-end;height:10px}
.oh-sb-signal span{width:3px;background:#fff;border-radius:.5px}
.oh-sb-signal span:nth-child(1){height:3px}.oh-sb-signal span:nth-child(2){height:5px}
.oh-sb-signal span:nth-child(3){height:7px}.oh-sb-signal span:nth-child(4){height:10px}
.oh-sb-batt{width:22px;height:10px;border:1.5px solid rgba(255,255,255,.5);border-radius:3px;position:relative;margin-left:2px}
.oh-sb-batt::before{content:'';position:absolute;right:-3px;top:50%;transform:translateY(-50%);width:1.5px;height:4px;background:rgba(255,255,255,.5);border-radius:0 1px 1px 0}
.oh-sb-batt::after{content:'';position:absolute;left:1px;top:1px;bottom:1px;width:75%;background:#34c759;border-radius:1px}
.oh-phone-home{width:120px;height:4px;background:rgba(255,255,255,.2);border-radius:2px;margin:6px auto 4px;flex-shrink:0}
.oh-wa-header{background:#1f2c34;padding:8px 10px;display:flex;align-items:center;gap:8px;flex-shrink:0;border-bottom:1px solid rgba(255,255,255,.05)}
.oh-wa-back{color:#00a884;font-size:18px;flex-shrink:0}
.oh-wa-avatar{width:34px;height:34px;border-radius:50%;overflow:hidden;flex-shrink:0;background:#1a1a2e;display:flex;align-items:center;justify-content:center}
.oh-wa-info{flex:1;min-width:0}
.oh-wa-name{color:#e9edef;font-size:13px;font-weight:500}
.oh-wa-status{color:#8696a0;font-size:10.5px}
.oh-wa-actions{display:flex;gap:14px;flex-shrink:0}
.oh-wa-actions svg{width:18px;height:18px;stroke:#8696a0;fill:none;stroke-width:1.5}
.oh-wa-chat{flex:1;padding:8px 10px;overflow-y:auto;overflow-x:hidden;display:flex;flex-direction:column;gap:4px;-webkit-overflow-scrolling:touch;background:#0b141a;min-height:0}
.oh-wa-chat::-webkit-scrollbar{display:none}
.oh-wa-msg{max-width:85%;padding:5px 7px 4px;border-radius:7px;font-size:11px;line-height:1.4;opacity:0;transform:translateY(10px);animation:ohMsgIn .35s forwards;position:relative;word-wrap:break-word}
.oh-wa-msg.sent{background:#005c4b;color:#e9edef;align-self:flex-end;border-top-right-radius:2px;margin-right:2px}
.oh-wa-msg.recv{background:#202c33;color:#e9edef;align-self:flex-start;border-top-left-radius:2px;margin-left:2px}
.oh-wa-msg.sent::before{content:'';position:absolute;top:0;right:-6px;border-width:0 0 8px 8px;border-style:solid;border-color:transparent transparent transparent #005c4b}
.oh-wa-msg.recv::before{content:'';position:absolute;top:0;left:-6px;border-width:0 8px 8px 0;border-style:solid;border-color:transparent #202c33 transparent transparent}
.oh-wa-msg .oh-time{font-size:9px;color:rgba(255,255,255,.4);float:right;margin-left:6px;margin-top:3px;display:flex;align-items:center;gap:2px}
.oh-wa-msg.sent .oh-time::after{content:'';display:inline-block;width:14px;height:9px;background:url("data:image/svg+xml,%3Csvg viewBox='0 0 16 11' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.07.66L4.88 6.85 2.6 4.58l-.72.7 2.99 3 6.9-6.9-.7-.72zM7.17 6.85l-.71.71 2.99 3 6.9-6.9-.71-.71-6.19 6.19-2.28-2.29z' fill='%2353bdeb'/%3E%3C/svg%3E") no-repeat center/contain}
.oh-wa-typing{align-self:flex-start;background:#202c33;border-radius:8px;padding:8px 14px;display:none;margin-left:2px}
.oh-wa-typing span{display:inline-block;width:6px;height:6px;background:#8696a0;border-radius:50%;margin:0 1px;animation:ohTyping 1.2s infinite}
.oh-wa-typing span:nth-child(2){animation-delay:.2s}
.oh-wa-typing span:nth-child(3){animation-delay:.4s}
.oh-wa-input{background:#1f2c34;padding:6px 8px;display:flex;align-items:center;gap:6px;flex-shrink:0}
.oh-wa-input-box{flex:1;background:#2a3942;border-radius:20px;padding:7px 12px;display:flex;align-items:center;gap:6px}
.oh-wa-input-box span{color:#8696a0;font-size:12px}
.oh-wa-input-box svg{width:18px;height:18px;stroke:#8696a0;fill:none;stroke-width:1.5;flex-shrink:0}
.oh-wa-mic{width:36px;height:36px;border-radius:50%;background:#00a884;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.oh-wa-mic svg{width:18px;height:18px;fill:#fff;stroke:none}
.oh-wa-img{width:100%;border-radius:6px;margin-bottom:4px;background:#0d1a22;min-height:100px;overflow:hidden}
.oh-wa-img-inner{width:100%;aspect-ratio:16/10;background:linear-gradient(135deg,#0a0a1a 0%,#1a1035 30%,#0d1a2a 60%,#0a0a1a 100%);display:flex;flex-direction:column;align-items:center;justify-content:center;padding:12px;text-align:center;position:relative;overflow:hidden}
.oh-wa-img-inner::before{content:'';position:absolute;top:20%;left:10%;width:80%;height:60%;background:radial-gradient(ellipse,rgba(108,92,231,.15),transparent 70%);pointer-events:none}
@keyframes ohMsgIn{to{opacity:1;transform:translateY(0)}}
@keyframes ohTyping{0%,100%{transform:translateY(0)}50%{transform:translateY(-4px)}}
@media(max-width:768px){.oh-phone{width:280px}.oh-phone-outer{border-radius:40px}.oh-phone-frame{border-radius:38px}.oh-phone-inner{border-radius:36px}}
      `}} />
      <div className="oh-phone">
        <div className="oh-phone-outer">
          <div className="oh-phone-vol oh-phone-vol1"></div>
          <div className="oh-phone-vol oh-phone-vol2"></div>
          <div className="oh-phone-vol oh-phone-vol3"></div>
          <div className="oh-phone-frame">
            <div className="oh-phone-inner">
              <div className="oh-phone-notch"></div>
              <div className="oh-phone-screen">
                <div className="oh-phone-statusbar">
                  <span className="oh-sb-time">9:41</span>
                  <div className="oh-sb-right">
                    <div className="oh-sb-signal"><span></span><span></span><span></span><span></span></div>
                    <div className="oh-sb-batt"></div>
                  </div>
                </div>
                <div className="oh-wa-header">
                  <span className="oh-wa-back">‹</span>
                  <div className="oh-wa-avatar"><span style={{color:'#6c5ce7',fontSize:'20px'}}>🤖</span></div>
                  <div className="oh-wa-info">
                    <div className="oh-wa-name">AI Agent</div>
                    <div className="oh-wa-status">online</div>
                  </div>
                  <div className="oh-wa-actions">
                    <svg viewBox="0 0 24 24" strokeLinecap="round"><circle cx="12" cy="5" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="12" cy="19" r="1"/></svg>
                  </div>
                </div>
                <div className="oh-wa-chat" ref={chatRef}>
                  <div className="oh-wa-typing" ref={typingRef} style={{display:'none'}}>
                    <span></span><span></span><span></span>
                  </div>
                </div>
                <div className="oh-wa-input">
                  <div className="oh-wa-input-box">
                    <svg viewBox="0 0 24 24" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01"/></svg>
                    <span>Type a message</span>
                  </div>
                  <div className="oh-wa-mic"><svg viewBox="0 0 24 24"><path d="M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3zM19 10v2a7 7 0 01-14 0v-2M12 19v4m-4 0h8"/></svg></div>
                </div>
                <div className="oh-phone-home"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
